export function touchBanener(that) {
	// //选中的轮播图
	var box = document.querySelectorAll('.el-carousel__container')[1]
	var newBox = document.querySelectorAll('.el-carousel__container')[2]
	var startPoint = 0;
	var stopPoint = 0;
	//重置坐标
	var resetPoint = function() {
		startPoint = 0;
		stopPoint = 0;
	}
	// // 指示器1和指示器2
	//手指按下
	newBox.addEventListener("touchstart", function(e) {
		//手指点击位置的X坐标
		startPoint = e.changedTouches[0].pageX;
	});
	//手指滑动
	newBox.addEventListener("touchmove", function(e) {
		//手指滑动后终点位置X的坐标
		stopPoint = e.changedTouches[0].pageX;
	});
	//当手指抬起的时候，判断图片滚动离左右的距离
	newBox.addEventListener("touchend", function() {
		if (stopPoint == 0 || startPoint - stopPoint == 0) {
			resetPoint();
			return;
		}
		if (startPoint - stopPoint > 0) {
			resetPoint();
			that.$refs.slideCarousel.next();
			return;
		}
		if (startPoint - stopPoint < 0) {
			resetPoint();
			that.$refs.slideCarousel.prev();
			return;
		}
	});
	//手指按下
	box.addEventListener("touchstart", function(e) {
		//手指点击位置的X坐标
		startPoint = e.changedTouches[0].pageX;
	});
	//手指滑动
	box.addEventListener("touchmove", function(e) {
		//手指滑动后终点位置X的坐标
		stopPoint = e.changedTouches[0].pageX;
	});
	//当手指抬起的时候，判断图片滚动离左右的距离
	box.addEventListener("touchend", function() {
		if (stopPoint == 0 || startPoint - stopPoint == 0) {
			resetPoint();
			return;
		}
		if (startPoint - stopPoint > 0) {
			resetPoint();
			that.$refs.carousel.next();
			return;
		}
		if (startPoint - stopPoint < 0) {
			resetPoint();
			that.$refs.carousel.prev();
			return;
		}
	});
}
